<template>
  <b-link class="d-inline-flex align-items-center btn-price-list" @click="onclick">
    {{ $t('pages.checkins_detail.label_price_list') }}
    <Icon class="rounded-icon ml-3" name="arrowNarrowUpRight" width="27"/>
  </b-link>
</template>
<script>
export default {
  name: "PriceListButton",
  emits: ['click'],
  methods: {
    onclick() {
      this.$emit('click');
    }
  }
}
</script>


<style scoped>

</style>